<template>
  <PopupTemplate @close="close()">
    <div>
      <h2>¡Felicidades!</h2>
      <p>
        Hemos registrado tus datos para la participación en el sorteo.
      </p>
      <p>
        Te avisaremos si resultas agraciado.
      </p>
      <p>
        ¡Suerte!.
      </p>
    </div>
  </PopupTemplate>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable */

export default {
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped></style>
